<script>
    export let value = null
    export let label = null
    export let checked = false
    export let selected = false
    import scale from '../../custom/animations/scale'
    import Typography from './Typography.svelte'
    import { getContext, onMount } from 'svelte'
    // import { fade, scale } from 'svelte/transition'
    let disabled = getContext('radioDisabled')
    let radioValue = getContext('radioValue')
    let radioLabel = getContext('radioLabel')
    function updateState() {
        if (!$disabled) {
            radioValue.update((n) => {
                return value
            })
            radioLabel.update((n) => {
                return label
            })
        }
    }
    function keypress(event) {
        if (['Enter', 'Space'].indexOf(event.code) !== -1) updateState()
    }
    onMount((_) => {
        if (selected) {
            updateState()
        }
    })
    $: checked = $radioValue === value
</script>

<div
    on:keypress={keypress}
    tabindex="0"
    class={$disabled ? 'disabled' : ''}
    on:click={(_) => {
        updateState()
    }}
>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle cx="12" cy="12" r="11.5" stroke="#CCCCCC"></circle>
        {#if checked}
            <circle
                cx="12.0001"
                cy="12.0001"
                r="6.94737"
                fill-opacity={$disabled ? '0.3' : '1'}
                fill="#C21B17"
                transition:scale
            ></circle>
        {/if}
    </svg>
    {#if label}
        <Typography color={$disabled ? 'grey-800' : 'black'} type="caption"
            >{label}</Typography
        >
    {:else}
        <Typography color={$disabled ? 'grey-800' : 'black'} type="caption"
            ><slot /></Typography
        >
    {/if}
</div>

<style>
    div {
        display: flex;
        position: relative;
        flex-direction: row;
        align-items: center;
        gap: 10px;
        width: auto;
        cursor: pointer;
        user-select: none;
    }

    .disabled {
        cursor: no-drop;
    }
</style>
